import { DELETE_ENTRY_STRATEGY, DELETE_ENTRY_STRATEGY_FAILED, DELETE_ENTRY_STRATEGY_SUCCESSFUL } from './actionTypes';

export const deleteEntryStrategy = ({ deletedBy, id, token, history }) => {
  return {
    type: DELETE_ENTRY_STRATEGY,
    payload: { deletedBy, id, token, history },
  };
};

export const deleteEntryStrategySuccessful = (message) => {
  return {
    type: DELETE_ENTRY_STRATEGY_SUCCESSFUL,
    payload: { message },
  };
};

export const deleteEntryStrategyFailed = (message) => {
  return {
    type: DELETE_ENTRY_STRATEGY_FAILED,
    payload: message,
  };
};
